/**
 * referralCode: carries a friend's invite code from the link they shared
 * (lusuku.ug/?ref=CODE) to the moment this shopper creates an account, which
 * may be days later and several pages away.
 *
 * Kept in localStorage for 30 days. The server decides everything else
 * (whether the code is valid, whether this account is new, what each side
 * gets); the client only carries the code.
 */

const REFERRAL_STORAGE_KEY = "lusuku.referralCode";
const REFERRAL_TTL_MS = 30 * 24 * 60 * 60 * 1000;

/* Codes are short and plain; anything else in ?ref= is ignored. */
const REFERRAL_CODE_PATTERN = /^[A-Za-z0-9_-]{4,32}$/;

export const referralCodeFromSearch = (search = "") => {
  const code = new URLSearchParams(search).get("ref");
  return code && REFERRAL_CODE_PATTERN.test(code.trim()) ? code.trim().toUpperCase() : null;
};

export const rememberReferralCode = (code, now = Date.now()) => {
  if (!code || !REFERRAL_CODE_PATTERN.test(code)) return;
  try {
    localStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify({ code, savedAt: now }));
  } catch (_) {
    /* storage disabled: the code is simply not carried */
  }
};

export const pendingReferralCode = (now = Date.now()) => {
  try {
    const stored = JSON.parse(localStorage.getItem(REFERRAL_STORAGE_KEY) || "null");
    if (!stored?.code || !(now - Number(stored.savedAt) < REFERRAL_TTL_MS)) return null;
    return stored.code;
  } catch (_) {
    return null;
  }
};

export const clearReferralCode = () => {
  try {
    localStorage.removeItem(REFERRAL_STORAGE_KEY);
  } catch (_) {
    /* nothing to clear */
  }
};

/* The field account-creation requests carry; absent when there is no code. */
export const referralCodeField = () => {
  const code = pendingReferralCode();
  return code ? { referralCode: code } : {};
};
